import React from 'react';
import { MILKING_MENU_GROUP_HINTS } from '../../constants/milkingWorkflowSteps';

export default function MilkingMenuGroupLabel({ groupKey }) {
  const meta = MILKING_MENU_GROUP_HINTS[groupKey];
  if (!meta) return null;

  return (
    <span className="milking-sidebar-group-oneline" title={`${meta.title} — ${meta.hint}`}>
      <span className="milking-sidebar-step">Step {meta.stepLabel}</span>
      {meta.title}
      <span className="milking-sidebar-group-hint-inline"> · {meta.hint}</span>
    </span>
  );
}
